import React from 'react';
import PageTitle from '../component/typography/PageTitle';
import Info from '../constants/info';

const InfoPage = ({ data }) => {
  const { email } = data;
  return (
    <>
      <div>
        <PageTitle>{Info.greeting}</PageTitle>
      </div>
      <div className='sisp-info-content'>
        <p>
          {Info.acknowledgementLine1} <b>{email}</b>
          {Info.acknowledgementLine2}
        </p>
      </div>
      <div>
        <span>{Info.contact}</span>
        <b className='sisp-info-contact'>
          <a href={`mailto:${Info.contactEmail}`} target='_top'>
            {Info.contactEmail}
          </a>
        </b>
        <span>{Info.contactTrail}</span>
      </div>
    </>
  );
};

export default InfoPage;
